import { createAction } from '@reduxjs/toolkit';
import * as ActionTypes from './types';
import {
    CHANGE_ANSWER_STATE,
    CLEAR_ANSWERS_FROM_GROUP_STEPS,
    CLEAR_ANSWERS_STATE,
    CLEAR_POLICY_TYPE_COMBINATION,
    GET_DRAFT_CLAIM_APPLICATION_BY_USER,
    GET_DRAFT_CLAIM_APPLICATION_BY_USER_FAILED,
    GET_DRAFT_CLAIM_APPLICATION_BY_USER_SUCCESS,
    GET_DRAFT_CLAIM_APPLICATION_LIST_BY_USER,
    GET_DRAFT_CLAIM_APPLICATION_LIST_BY_USER_FAILED,
    GET_DRAFT_CLAIM_APPLICATION_LIST_BY_USER_SUCCESS,
    GET_NO_SUBMITTED_DRAFT_CLAIM_APPLICATION_BY_USER,
    GET_NO_SUBMITTED_DRAFT_CLAIM_APPLICATION_BY_USER_FAILED,
    GET_NO_SUBMITTED_DRAFT_CLAIM_APPLICATION_BY_USER_SUCCESS,
} from './types';
export type ChangePayload = {
    name: string;
    value: string;
};

export const changeAnswerState = createAction<changeAnswerStateAction>(
    ActionTypes.CHANGE_ANSWER_STATE,
);
export const clearAnswersFromGroupSteps =
    createAction<clearAnswersFromGroupStepsAction>(
        ActionTypes.CLEAR_ANSWERS_FROM_GROUP_STEPS,
    );
export const clearAnswersState = createAction<
    clearAnswersStateAction | undefined
>(ActionTypes.CLEAR_ANSWERS_STATE);
export const clearPolicyTypeCombination = createAction<
    clearPolicyTypeCombinationAction | undefined
>(ActionTypes.CLEAR_POLICY_TYPE_COMBINATION);
export const fetchDraftClaimApplicationByUser =
    createAction<fetchDraftClaimApplicationByUserAction>(
        ActionTypes.GET_DRAFT_CLAIM_APPLICATION_BY_USER,
    );
export const fetchDraftClaimApplicationByUserSuccess =
    createAction<fetchDraftClaimApplicationByUserSuccessAction>(
        ActionTypes.GET_DRAFT_CLAIM_APPLICATION_BY_USER_SUCCESS,
    );
export const fetchDraftClaimApplicationByUserFailed =
    createAction<fetchDraftClaimApplicationByUserFailedAction>(
        ActionTypes.GET_DRAFT_CLAIM_APPLICATION_BY_USER_FAILED,
    );
export const fetchNoSubmittedDraftClaimApplicationByUser =
    createAction<fetchNoSubmittedDraftClaimApplicationByUserAction>(
        ActionTypes.GET_NO_SUBMITTED_DRAFT_CLAIM_APPLICATION_BY_USER,
    );
export const fetchNoSubmittedDraftClaimApplicationByUserSuccess =
    createAction<fetchNoSubmittedDraftClaimApplicationByUserSuccessAction>(
        ActionTypes.GET_NO_SUBMITTED_DRAFT_CLAIM_APPLICATION_BY_USER_SUCCESS,
    );
export const fetchNoSubmittedDraftClaimApplicationByUserFailed =
    createAction<fetchNoSubmittedDraftClaimApplicationByUserFailedAction>(
        ActionTypes.GET_NO_SUBMITTED_DRAFT_CLAIM_APPLICATION_BY_USER_FAILED,
    );
export const fetchDraftClaimApplicationListByUser =
    createAction<fetchDraftClaimApplicationListByUserAction>(
        ActionTypes.GET_DRAFT_CLAIM_APPLICATION_LIST_BY_USER,
    );
export const fetchDraftClaimApplicationListByUserSuccess =
    createAction<fetchDraftClaimApplicationListByUserSuccessAction>(
        ActionTypes.GET_DRAFT_CLAIM_APPLICATION_LIST_BY_USER_SUCCESS,
    );
export const fetchDraftClaimApplicationListByUserFailed =
    createAction<fetchDraftClaimApplicationListByUserFailedAction>(
        ActionTypes.GET_DRAFT_CLAIM_APPLICATION_LIST_BY_USER_FAILED,
    );

export interface clearAnswersFromGroupStepsAction {
    type: typeof CLEAR_ANSWERS_FROM_GROUP_STEPS;
}

export interface clearAnswersStateAction {
    type?: typeof CLEAR_ANSWERS_STATE;
    payload?: unknown;
}
export interface changeAnswerStateAction {
    type: typeof CHANGE_ANSWER_STATE;
    payload: ChangePayload;
}

export interface clearPolicyTypeCombinationAction {
    type: typeof CLEAR_POLICY_TYPE_COMBINATION;
}

export interface fetchDraftClaimApplicationByUserAction {
    type: typeof GET_DRAFT_CLAIM_APPLICATION_BY_USER;
    payload: string;
}

export interface fetchDraftClaimApplicationByUserSuccessAction {
    type: typeof GET_DRAFT_CLAIM_APPLICATION_BY_USER_SUCCESS;
}

export interface fetchDraftClaimApplicationByUserFailedAction {
    type: typeof GET_DRAFT_CLAIM_APPLICATION_BY_USER_FAILED;
}

export interface fetchNoSubmittedDraftClaimApplicationByUserAction {
    type: typeof GET_NO_SUBMITTED_DRAFT_CLAIM_APPLICATION_BY_USER;
    payload: undefined;
}

export interface fetchNoSubmittedDraftClaimApplicationByUserSuccessAction {
    type: typeof GET_NO_SUBMITTED_DRAFT_CLAIM_APPLICATION_BY_USER_SUCCESS;
}

export interface fetchNoSubmittedDraftClaimApplicationByUserFailedAction {
    type: typeof GET_NO_SUBMITTED_DRAFT_CLAIM_APPLICATION_BY_USER_FAILED;
}
export interface fetchDraftClaimApplicationListByUserAction {
    type: typeof GET_DRAFT_CLAIM_APPLICATION_LIST_BY_USER;
    payload: unknown;
}

export interface fetchDraftClaimApplicationListByUserSuccessAction {
    type: typeof GET_DRAFT_CLAIM_APPLICATION_LIST_BY_USER_SUCCESS;
}

export interface fetchDraftClaimApplicationListByUserFailedAction {
    type: typeof GET_DRAFT_CLAIM_APPLICATION_LIST_BY_USER_FAILED;
}
